<script defer>
  // @ts-nocheck
  import { goto } from "$app/navigation";
  import { routes } from "./routes.js";
  import { afterUpdate, onMount } from "svelte";
  import { page } from "$app/stores";
  import { browser } from "$app/environment";

  //**COMPONENTS**/
  import HeaderCart from "./HeaderCart.svelte";
  import HeaderCustomerModule from "./HeaderCustomerModule.svelte";
  import HeaderMenu from "./HeaderMenu.svelte";
  import HeaderSearch from "./HeaderSearch.svelte";
  import NaPictureRegular from "$lib/components/global/Na_Picture_Regular.svelte";
  import NaVideoVertical from "$lib/components/global/NA_Video_Vertical.svelte";
  import Logo from "$lib/components/layout/Logo.svelte";

  /**@type {any}*/
  let content = [];
  /**@type {number | ??}*/
  let selectedIndex = null;
  /**@type {boolean}*/
  let isChildrens = false;
    /**@type {number}*/
    let selectSubmenu = 0;
    
  /** @param {any}index, @param {any}summary */
  function handleContent(summary, index) {
    content = summary;
    selectedIndex = index;
    selectSubmenu = 0;
  }

  function closeContent() {
    content = [];
    selectedIndex = null;
  }

  // @ts-ignore
  const bodyScroll = {
    prevent() {
      // @ts-ignore
      document.querySelector("body").style.overflow = "hidden";
    },
    allow() {
      // @ts-ignore
      document.querySelector("body").style.overflow = null;
    },
  };



  /**@param {number}i*/
  function openSubmenu(i) {
    selectSubmenu = i;
    isChildrens = content[selectSubmenu].childrens ? true : false;
  }

  $: {
    selectedIndex;
    isChildrens = false;
  }

  /**@param {string}route*/
  const enterRoute = (route) => {
    goto(route, { noScroll: false });
    closeContent();
  };

  /**@type {HTMLElement}*/
  let header;
  /**@type {number}*/
  let y = 0;
  /**@type {number}*/
  let x;
  /**@type {number}*/
  let offsetTop = 0;

  $: {
    y;
    x;
    afterUpdate(() => {
      if (x >= 550) {
        if (y >= 34) {
          header.style.backgroundColor = "var(--primary-color)";
          header.style.top = "0px";
        } else {
          if ($page.route.id !== "/") {
            header.style.backgroundColor = "var(--primary-color)";
            header.style.top = "34px";
          } else {
            header.style.backgroundColor = "rgba(var(--primary-colorRgb), 0.27)";
            header.style.top = "34px";
          }
        }
      } else {
        header.style.backgroundColor = "var(--primary-color)";
        header.style.top = "0px";
      }
    });
  }

  $: {
    y;
    afterUpdate(() => {
      offsetTop = header.getBoundingClientRect().top;
    });
  }

  $: {
    $page;
    afterUpdate(() => {
      if ($page.route.id !== "/") {
        header.style.backgroundColor = "var(--primary-color)";
      }
    });
  }

  /**@type {any}*/
  let menuContent;
  const moveMenu = () => menuContent.scrollBy(400, 0);

  function scrollingX(e) {
    if (window?.navigator.userAgent.includes("Windows")) {
      menuContent.scrollLeft += e.deltaY * 10;
    }
  }

  let isOpen = false;
</script>

<svelte:window bind:scrollY={y} bind:innerWidth={x} />

<header on:mouseleave={closeContent} bind:this={header}>
  <div class="header-container">
    <div class="menu-mobile">
      <HeaderMenu bind:isOpen />
    </div>
    <div class="logo" class:hidden={isOpen}>
      <Logo />
    </div>
    <div class="menu-desktop">
      <nav class="navegation" aria-label="Main navigation">
        <ul class="main-menu">
          {#if routes?.length > 0}
            {#each routes as route, index}
              {@const current = $page.url.pathname === route.link}
              <li
                class="unit-menu"
                on:mouseenter={() => handleContent(route?.content, index)}
                on:focusin={() => handleContent(route?.content, index)}
              >
                <button
                  aria-current={current ? "page" : false}
                  on:click={() => enterRoute(route?.link)}
                  class={selectedIndex == index ? "link link-active" : "link"}
                  class:fontMedium={$page.route.id !== "/"}
                >
                  {@html route?.summary}
                </button>
              </li>
              {#if content !== undefined}
                <li class={selectedIndex == index || content?.length > 0 ? "content-menu active" : "content-menu"} 
                      style={`top: calc(var(--header-height) + ${offsetTop}px`}>
                  <ul class="wrap">
                    <li class="content-elements">
                      {#each content as item, index}
                        <div class="element-link">
                          <a
                            class:select={selectSubmenu == index}
                            on:mouseenter={() => openSubmenu(index)}
                            on:focusin={() => openSubmenu(index)}
                            on:click={closeContent}
                            href={item?.link}
                          >
                            {@html item?.main}
                          </a>
                        </div>
                      {/each}
                    </li>
                    {#each content as item, index}
                      <div class={selectSubmenu === index ? "over-hidden" : "hidden"}>
                        {#if selectSubmenu == index}
                          <div class="dynamic-menu">
                            <ul
                              bind:this={menuContent}
                              class="menu-cards"
                              on:wheel={(e) => scrollingX(e)}
                              on:mouseenter={() => bodyScroll.prevent()}
                              on:mouseleave={() => bodyScroll.allow()}
                            >
                              {#if item?.childrens}
                                {#each item?.childrens as child}
                                  <li class="items">
                                    <a href={child?.link} on:click={closeContent}>
                                      {#if child.image}
                                        <div class="image">
                                          <NaPictureRegular mediaQueryImages={child?.image} />
                                        </div>
                                      {:else if child.video}
                                        <div class="image">
                                          <NaVideoVertical
                                            videoUrl={child.video}
                                            poster={child?.poster}
                                          />
                                        </div>
                                      {/if}
                                      <div class="text">
                                        <span>{@html child?.text}</span>
                                      </div>
                                    </a>
                                  </li>
                                {/each}
                              {/if}
                            </ul>
                            {#if item.seeMore}
                              <a href={item.link} on:click={closeContent} class="show-more">
                                SHOW MORE
                              </a>
                            {/if}
                          </div>
                        {/if}
                      </div>
                    {/each}
                  </ul>
                  {#if isChildrens}
                    <button class="arrow" on:click={moveMenu}>
                      <img src="/images/global/dark_product_right.svg" alt="" />
                    </button>
                  {/if}
                </li>
              {/if}
            {/each}
          {/if}
        </ul>
      </nav>
    </div>
    <div class="icons" class:hidden={isOpen}>
      <div class="search">
        <HeaderSearch />
      </div>
      <div class="user">
        <HeaderCustomerModule />
      </div>
      <div class="shopping-bag">
        <HeaderCart />
      </div>
    </div>
  </div>
</header>

<span class="label" id="openBurgerButton">Open menu</span>
<span class="label" id="close-menu">Close menu</span>
<span class="label" id="logo"> Gelish & Morgan Taylor Logo, Go to home page </span>
<span class="label" id="search">Button to open search module</span>
<span class="label" id="customer-signedin-icon">Customer icon logged</span>
<span class="label" id="forget-password-button">Go to Forgot you password</span>
<span class="label" id="sigup-page-in-page">Go to Sign in page</span>
<span class="label" id="iconCartButton">Open Shopping cart modal</span>
<span class="label" id="close-modal"> Close modal</span>
<span class="label" id="action_button_product-remove"> Remove product from cart </span>

<style>
  a {
    text-decoration: none;
    display: block;
  }
  header {
    background-color: rgba(var(--primary-colorRgb), 0.27);
    height: var(--header-height);
    width: 100%;
    position: fixed;
    z-index: 999;
    top: 34px;
    transition: all 0.5s ease;
    cursor: pointer;
    color: var(--secondary-color);
    user-select: none;
  }
  header:hover,
  header:focus-within {
    background-color: var(--primary-color) !important;
  }
  .header-container {
    background-color: transparent;
    transition: all 0.5s ease;
    position: relative;
    z-index: 3;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 36px 10px 50px;
    max-width: 1920px;
    margin: 0 auto;
    height: var(--header-height);
    font-family: "gotham-medium";
  }
  .menu-mobile {
    display: none;
    justify-content: center;
    align-items: center;
    width: 22px;
    height: 22px;
  }
  .logo {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 9999;
  }
  .menu-desktop {
    display: flex;
    justify-content: center;
    align-items: flex-start;
  }
  .icons {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    z-index: 1000;
  }
  .search {
    padding-top: 6px;
  }
  .shopping-bag {
    padding-top: 5px;
  }
  .navegation {
    width: 100%;
    height: 100%;
  }
  .navegation * {
    overflow: hidden;
  }
  .navegation .main-menu {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    transition: all 0.5s ease;
  }
  .navegation .main-menu .unit-menu {
    list-style: none;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: "gotham-medium";
  }
  .navegation .main-menu .unit-menu:hover,
  .navegation .main-menu .unit-menu:focus {
    font-family: "gotham-bold";
  }
  .link {
    color: var(--secondary-color);
    background: none;
    text-align: center;
    text-decoration: none;
    text-transform: uppercase;
    font-size: 0.875em;
    font-family: "gotham-bold";
    letter-spacing: 1px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 10px;
    border: none;
    cursor: pointer;
    transition: all 0.5s ease;
  }
  .fontMedium {
    font-family: "gotham-book";
  }
  header:hover .link,
  header:focus .link {
    font-family: "gotham-book";
  }
  .link-active {
    width: 100%;
    height: 100%;
    position: relative;
    z-index: 9999;
  }
  .link-active::before {
    content: "";
    width: 0;
    height: 3px;
    position: absolute;
    bottom: 0;
    left: 50%;
    border-radius: 150px;
    background-color: var(--secondary-color);
    animation: link 0.5s ease-out forwards;
    z-index: 99;
  }
  @keyframes link {
    from {
      width: 0;
      left: 50%;
    }
    to {
      width: 100%;
      left: 0;
    }
  }
  .content-menu {
    overflow-y: hidden;
    background-color: var(--primary-color);
    position: fixed;
    width: 100vw;
    height: 0;
    /* top: calc(var(--header-height) + 34px); */
    left: 0;
    z-index: 999;
    display: flex;
    justify-content: center;
    padding-top: 40px;
    opacity: 0;
    overflow: hidden;
    transition: all 0.5s ease;
  }
  .active {
    height: 700px;
    max-height: 80svh;
    opacity: 1;
    transition: all 0.5s ease;
    background-color: var(--primary-color);
  }
  .singleMenu {
    height: 120px;
    max-height: 120px;
    opacity: 1;
    transition: all 0.5s ease;
    background-color: var(--primary-color);
    flex-direction: column;
  }
  .wrap {
    display: flex;
    justify-content: space-between;
    max-width: 1366px;
    width: 100%;
    position: relative;
  }
  .singleMenu .wrap {
    justify-content: center;
    margin: auto;
    max-width: fit-content;
  }
  .arrow {
    background: none;
    border: none;
    width: 60px;
    height: 60px;
    position: absolute;
    top: 35%;
    transform: translateY(-50%);
    right: 10svw;
    z-index: 99999999;
    cursor: pointer;
  }
  .arrow img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
  .content-elements {
    width: fit-content;
    height: 100%;
    padding: 20px 30px 0 63px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    gap: 1em;
    min-width: 350px;
  }
  .singleMenu .wrap .content-elements {
    flex-direction: row;
    width: 100%;
    align-items: flex-start;
    justify-content: center;
    padding: 0;
    gap: 1em;
  }
  .content-menu .element-link {
    height: min-content !important;
  }
  .content-elements .element-link a {
    text-decoration: none;
    display: block;
    color: var(--secondary-color);
    font-size: 1em;
    font-weight: 500;
    position: relative;
    padding: 5px 10px 5px 10px;
    transition: all 0.5s ease;
    text-transform: uppercase;
    text-wrap: nowrap;
    list-style: none;
    border-radius: 5px;
  }
  .content-elements .element-link a::before {
    content: "";
    width: 0;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 0;
    background-color: var(--collection);
    transition: all 0.5s ease;
    z-index: -1;
  }
  .content-elements .element-link a.select {
    text-decoration: none;
    color: var(--secondary-color);
    font-weight: 500;
    text-transform: uppercase;
    position: relative;
    padding: 5px 10px 5px 10px;
    transition: all 0.5s ease;
    text-wrap: nowrap;
    border-radius: 5px;
  }
  .content-elements .element-link a.select::before {
    content: "";
    width: 0;
    height: 120%;
    position: absolute;
    top: 0;
    left: -10%;
    border-radius: 0;
    background-color: var(--collection);
    transition: all 0.5s ease;
    z-index: -1;
    border-radius: 5px;
  }
  .content-elements .element-link a:hover::before,
  .content-elements .element-link a:focus-within::before {
    width: 110%;
    left: 0;
  }
  .content-elements .element-link a:hover,
  .content-elements .element-link a:focus-within {
    color: #fdfdfd;
    z-index: 999;
  }
  header:hover .content-elements .element-link a.select::before,
  header:focus-within .content-elements .element-link a.select::before {
    width: 110%;
    left: 0;
  }
  header:hover .content-elements .element-link a.select,
  header:focus-within .content-elements .element-link a.select {
    color: #fdfdfd;
    z-index: 999;
  }
  .content-menu:hover .content-elements .element-link a.select::before,
  .content-menu:focus-within .content-elements .element-link a.select::before {
    width: 110%;
    left: 0;
  }
  .content-menu:hover .content-elements .element-link a.select,
  .content-menu:focus-within .content-elements .element-link a.select {
    color: #fdfdfd;
    z-index: 999;
  }
  .over-hidden {
    height: 100%;
    width: 100%;
    overflow: hidden;
    display: block;
  }
  .dynamic-menu {
    background-color: var(--primary-color);
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 60px 0px 0px;
    margin-bottom: 120px;
    gap: 15px;
    opacity: 1;
    transition: opacity 0.5s ease;
    position: relative;
    background-color: var(--primary-color);
    z-index: 999 !important;
    overflow: hidden;
  }
  .dynamic-menu ul.menu-cards {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    /* scroll-behavior: smooth; */
    scroll-snap-type: x mandatory;
    overflow-x: scroll;
    scrollbar-width: none;
  }
  @media (prefers-reduced-motion: no-preference) {
    .dynamic-menu ul.menu-cards {
      scroll-behavior: smooth;
    }
  }
  ul.menu-cards .items {
    min-width: 200px;
  }
  ul.menu-cards .items a {
    aspect-ratio: 1/1.7;
    display: flex !important;
    flex-direction: column;
    align-items: center;
    text-align: center;
    text-decoration: none;
    color: var(--secondary-color);
    font-size: 0.875em;
    line-height: 1.5em;
    font-weight: 500;
    min-width: 200px;
  }
  .menu-cards .items .image {
    width: 177px;
    height: 290px;
    overflow: hidden;
    box-shadow: 0 0 1px rgba(0, 0, 0, 0.1);
    border-radius: 12px;
    position: relative;
  }
  .menu-cards .items .text {
    height: fit-content;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 160px;
    padding: 10px 0;
    margin-top: 6px;
    transition: all 0.5s ease;
  }
  .menu-cards .items .text span {
    overflow: hidden;
    line-height: 1.2;
  }
  .dynamic-menu .show-more {
    border-radius: 30px;
    padding: 10px 30px;
    display: block;
    text-decoration: none;
    text-align: center;
    width: fit-content;
    background-color: var(--secondary-color);
    color: var(--primary-color);
  }
  @media (max-width: 1024px) {
    header {
      background-color: var(--primary-color) !important;
      position: sticky !important;
      top: 0;
    }
    .header-container {
      display: grid;
      grid-template-columns: 1fr 60% 1fr;
      width: 100svw;
      padding: 0 30px;
      margin: 0 auto;
    }
    .menu-mobile {
      display: flex;
      justify-self: start;
      z-index: 99;
      width: 31px;
      height: 100%;
    }
    .icons {
      justify-self: end;
    }
    .menu-desktop {
      display: none;
    }
  }
  @media (hover: none) and (max-width: 768px) {
    header {
      background-color: var(--primary-color) !important;
      position: sticky !important;
      top: 0;
      width: 100svw;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .menu-mobile {
      display: flex;
    }
    .menu-desktop {
      display: none;
    }
  }
  @media (max-width: 768px) {
    .header-container {
      display: grid;
      grid-template-columns: 1fr 60% 1fr;
      width: 100%;
      padding: 0 35px;
    }
    .search {
      display: none;
    }
    .user {
      display: none;
    }
    .shopping-bag {
      padding-top: 2px;
    }
    .icons {
      gap: 30px;
    }
  }
  @media (max-width: 560px) {
  }
  .hidden {
    display: none;
  }
</style>
